import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { SiteProvider } from "@/context/SiteContext";

// Public pages
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import About from "@/pages/About";
import JoinMission from "@/pages/JoinMission";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";
import SearchPage from "@/pages/Search";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Media from "@/pages/Media";
import Events from "@/pages/Events";

// Admin pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBooksList from "@/pages/admin/AdminBooksList";
import AdminBookEditor from "@/pages/admin/AdminBookEditor";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminGenericContent from "@/pages/admin/AdminGenericContent";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminTranslations from "@/pages/admin/AdminTranslations";
import AdminSiteSettings from "@/pages/admin/AdminSiteSettings";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminReservations from "@/pages/admin/AdminReservations";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrandingProvider>
          <SiteProvider>
            <AuthProvider>
            <BrowserRouter>
              <Routes>
                {/* Public site */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/books" element={<Books />} />
                  <Route path="/books/:slug" element={<BookDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/join" element={<JoinMission />} />
                  <Route path="/join-the-movement" element={<JoinMission />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/research-themes" element={<ComingSoon title="Research Themes" description="Category pages for civilizational continuity, Indus-Saraswati archaeology, epic chronology, maritime connections, colonial historiography and more will be published here." />} />
                  <Route path="/membership" element={<ComingSoon title="Membership" description="Reader, Student, Research, Educator, Institutional, Supporting and Lifetime memberships will open once the member portal is activated." />} />
                  <Route path="/media" element={<Media />} />
                  <Route path="/articles" element={<Articles />} />
                  <Route path="/articles/:slug" element={<ArticleDetail />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/legal/:page" element={<ComingSoon title="Legal Notice" description="This legal draft is under professional review before publication." />} />
                  <Route path="*" element={<ComingSoon title="Page Not Found" description="The page you are looking for is not available." />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="books" element={<AdminBooksList />} />
                  <Route path="books/new" element={<AdminBookEditor />} />
                  <Route path="books/:id" element={<AdminBookEditor />} />
                  <Route path="media" element={<AdminMedia />} />
                  <Route path="reservations" element={<AdminReservations />} />
                  <Route path="submissions" element={<AdminSubmissions />} />
                  <Route path="content/:ctype" element={<AdminGenericContent />} />
                  <Route path="staff" element={<AdminStaff />} />
                  <Route path="activity" element={<AdminActivity />} />
                  <Route path="homepage" element={<AdminHomepage />} />
                  <Route path="about" element={<AdminAbout />} />
                  <Route path="translations" element={<AdminTranslations />} />
                  <Route path="settings" element={<AdminSiteSettings />} />
                </Route>
              </Routes>
            </BrowserRouter>
            </AuthProvider>
          </SiteProvider>
        </BrandingProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
